import React from "react";
import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import Select from "react-select";

const TypeSelect = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: 15 }}>
          <Select
            closeMenuOnSelect={true}
            placeholder="Registration Type"
            onChange={props.handleChange}
            options={props.options}
            value={props.selectedOption}
          />
        </div>
      </Modal.Body>
      <Modal.Body>
        <div style={{ marginBottom: 15 }}>
          <Select
            closeMenuOnSelect={true}
            placeholder="Type"
            onChange={props.handleChanged}
            options={props.optionss}
            value={props.selectedOptions}
          />
        </div>
      </Modal.Body>
      {props.showRegChannelFilter ? (
        <Modal.Body>
          <div style={{ marginBottom: 15 }}>
            <Select
              closeMenuOnSelect={true}
              placeholder="Channel"
              onChange={props.handleRegChannelChange}
              options={props.channelOptions}
              value={props.selectedRegChannelOption}
            />
          </div>
        </Modal.Body>
      ) : (
        ""
      )}
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button variant="primary" color="primary" onClick={props.statusFilter}>
          Save{" "}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TypeSelect;
